import {
    ROLE,
    COMMUNITY,
    COMMUNITY_FAQ,
    COMMUNITY_FAQ_ADD,
    COMMUNITY_FAQ_DETAIL,
    COMMUNITY_FAQ_EDIT,
    COMMUNITY_FAQ_PATH,
    COMMUNITY_NOTICE,
    COMMUNITY_NOTICE_ADD,
    COMMUNITY_NOTICE_ADD_PATH,
    COMMUNITY_NOTICE_DETAIL,
    COMMUNITY_NOTICE_DETAIL_PATH,
    COMMUNITY_NOTICE_EDIT,
    COMMUNITY_NOTICE_EDIT_PATH,
    COMMUNITY_NOTICE_PATH,
    COMMUNITY_PATH,
    COMMUNITY_QNA,
    COMMUNITY_QNA_ADD,
    COMMUNITY_QNA_ADD_PATH,
    COMMUNITY_QNA_DETAIL,
    COMMUNITY_QNA_DETAIL_PATH,
    COMMUNITY_QNA_EDIT,
    COMMUNITY_QNA_EDIT_PATH,
    COMMUNITY_QNA_PATH,
    ENROLMENT,
    ENROLMENT_ENROLMENT_RESULT,
    ENROLMENT_ENROLMENT_RESULT_PATH,
    ENROLMENT_PATH,
    ENROLMENT_SCHEDULE_TABLE,
    ENROLMENT_SCHEDULE_TABLE_PATH,
    ENROLMENT_SEARCH_SUBJECT,
    ENROLMENT_SEARCH_SUBJECT_PATH,
    SEMESTER,
    SEMESTER_ENROLMENT_STATUS,
    SEMESTER_ENROLMENT_STATUS_PATH,
    SEMESTER_TOTAL_ENROLMENT_STATUS,
    SEMESTER_TOTAL_ENROLMENT_STATUS_PATH,
    SEMESTER_ENROLMENT_MANAGEMENT,
    SEMESTER_ENROLMENT_MANAGEMENT_PATH,
    SEMESTER_PATH,
    SEMESTER_STUDENT_ENROLMENT_CHECK,
    SEMESTER_STUDENT_ENROLMENT_CHECK_PATH,
    SEMESTER_STUDENT_UNIVERSITY,
    SEMESTER_STUDENT_UNIVERSITY_PATH,
    SEMESTER_SUBJECT,
    SEMESTER_SUBJECT_PATH,
    SUBJECT_SEARCH,
    SUBJECT_SEARCH_BODY,
    SUBJECT_SEARCH_BODY_PATH,
    SUBJECT_SEARCH_PATH,
    SYSTEM,
    SYSTEM_COMMON_CODE,
    SYSTEM_COMMON_CODE_PATH,
    SYSTEM_PATH,
    SYSTEM_SUBJECT_CODE,
    SYSTEM_SUBJECT_CODE_PATH,
    SYSTEM_TERM,
    SYSTEM_TERM_PATH,
    SYSTEM_ENROLMENT_NOTICE,
    SYSTEM_ENROLMENT_NOTICE_PATH,
    SYSTEM_UNIVERSITY,
    SYSTEM_UNIVERSITY_PATH,
    SYSTEM_UNIVERSITY_MANAGER,
    SYSTEM_UNIVERSITY_MANAGER_PATH,
    SYSTEM_USER,
    SYSTEM_USER_PATH,
    COMMUNITY_FAQ_EDIT_PATH,
    COMMUNITY_FAQ_DETAIL_PATH,
    COMMUNITY_FAQ_ADD_PATH,
    SYSTEM_LOGIN_HISTORY,
    SYSTEM_LOGIN_HISTORY_PATH,
    SMS,
    SMS_PATH,
    SMS_SEND,
    SMS_SEND_PATH,
    SMS_HISTORY,
    SMS_HISTORY_PATH,
    // TEST,
    // TEST_PATH,
    // TEST_MODAL,
    // TEST_MODAL_PATH,
} from './Constant';

let VIEW_HOME = {
    title: 'HOME',
    subTitle: null,
    isMenu: false,
    pathKey: '',
    path: '',
    privilege: [],
};

// // TODO 삭제
// let VIEW_TEST = {
//     title: '테스트',
//     subTitle: null,
//     isMenu: true,
//     pathKey: TEST,
//     path: TEST_PATH,
//     privilege: [],
// };
// // TODO 삭제
// let VIEW_TEST_MODAL = {
//     title: '모달/팝업 테스트',
//     subTitle: null,
//     isMenu: true,
//     pathKey: TEST_MODAL,
//     path: TEST_MODAL_PATH,
//     privilege: [],
// };

/* -------------------------------------------- */
let VIEW_SMS = {
    title: 'SMS',
    subTitle: null,
    isMenu: true,
    pathKey: SMS,
    path: SMS_PATH,
    privilege: [ROLE.ADMIN, ROLE.STAFF],
};

export const VIEW_SMS_SEND = {
    title: 'SMS발송',
    subTitle: 'SMS를 발송합니다. 직접 입력 또는 검색하여 수신자를 추가할 수 있습니다.',
    isMenu: true,
    pathKey: SMS_SEND,
    path: SMS_SEND_PATH,
    privilege: [ROLE.ADMIN, ROLE.STAFF],
};

export const VIEW_SMS_HISTORY = {
    title: 'SMS발송이력',
    subTitle: 'SMS 발송이력을 조회합니다.',
    isMenu: true,
    pathKey: SMS_HISTORY,
    path: SMS_HISTORY_PATH,
    privilege: [ROLE.ADMIN, ROLE.STAFF],
};

/* -------------------------------------------- */
let VIEW_SUBJECT_SEARCH = {
    title: '강의조회',
    subTitle: null,
    isMenu: true,
    pathKey: SUBJECT_SEARCH,
    path: SUBJECT_SEARCH_PATH,
    privilege: [],
};
export const VIEW_SUBJECT_SEARCH_BODY = {
    title: '강의조회',
    subTitle: '혁신융합대학사업(미래자동차)에 등록된 강의를 조회합니다.',
    isMenu: true,
    pathKey: SUBJECT_SEARCH_BODY,
    path: SUBJECT_SEARCH_BODY_PATH,
    privilege: [],
};
/* -------------------------------------------- */
let VIEW_SYSTEM = {
    title: '시스템관리',
    subTitle: null,
    isMenu: true,
    pathKey: SYSTEM,
    path: SYSTEM_PATH,
    privilege: [ROLE.ADMIN],
};
export const VIEW_SYSTEM_TERM = {
    title: '학기 관리',
    subTitle: '혁신융합대학사업(미래자동차)의 학기 정보를 관리합니다.',
    isMenu: true,
    pathKey: SYSTEM_TERM,
    path: SYSTEM_TERM_PATH,
    privilege: [ROLE.ADMIN],
};
export const VIEW_SYSTEM_ENROLMENT_NOTICE = {
    title: '수강신청 유의사항관리',
    subTitle: '수강 신청시 필요한 공통 유의사항을 학기별로 작성할 수 있습니다.',
    isMenu: true,
    pathKey: SYSTEM_ENROLMENT_NOTICE,
    path: SYSTEM_ENROLMENT_NOTICE_PATH,
    privilege: [ROLE.ADMIN],
};
export const VIEW_SYSTEM_UNIVERSITY = {
    title: '참여대학 관리',
    subTitle: '혁신융합대학사업(미래자동차)의 참여대학 정보를 등록 관리합니다.',
    isMenu: true,
    pathKey: SYSTEM_UNIVERSITY,
    path: SYSTEM_UNIVERSITY_PATH,
    privilege: [ROLE.ADMIN],
};
export const VIEW_SYSTEM_UNIVERSITY_MANAGER = {
    title: '참여대학 교직원 관리',
    subTitle: '혁신융합대학사업(미래자동차)의 컨소시엄 참여대학의 교직원 정보를 등록 관리합니다.',
    isMenu: true,
    pathKey: SYSTEM_UNIVERSITY_MANAGER,
    path: SYSTEM_UNIVERSITY_MANAGER_PATH,
    privilege: [ROLE.ADMIN],
};
export const VIEW_SYSTEM_SUBJECT_CODE = {
    title: '교과목 관리',
    subTitle: '혁신융합대학사업(미래자동차)의 마이크로디그리 과정의 표준 교과목 정보를 관리합니다.',
    isMenu: true,
    pathKey: SYSTEM_SUBJECT_CODE,
    path: SYSTEM_SUBJECT_CODE_PATH,
    privilege: [ROLE.ADMIN],
};
export const VIEW_SYSTEM_COMMON_CODE = {
    title: '공통코드 관리',
    subTitle: '시스템에서 사용되는 공통코드 정보를 관리합니다.',
    isMenu: true,
    pathKey: SYSTEM_COMMON_CODE,
    path: SYSTEM_COMMON_CODE_PATH,
    privilege: [ROLE.ADMIN],
};
export const VIEW_SYSTEM_USER = {
    title: '사용자 관리',
    subTitle: '시스템에서 사용되는 사용자 정보를 관리합니다.',
    isMenu: true,
    pathKey: SYSTEM_USER,
    path: SYSTEM_USER_PATH,
    privilege: [ROLE.ADMIN],
};
export const VIEW_SYSTEM_LOGIN_HISTORY = {
    title: '로그인 이력',
    subTitle: '로그인 이력을 조회합니다.',
    isMenu: true,
    pathKey: SYSTEM_LOGIN_HISTORY,
    path: SYSTEM_LOGIN_HISTORY_PATH,
    privilege: [ROLE.ADMIN],
};
/* -------------------------------------------- */
let VIEW_SEMESTER = {
    title: '수강지원',
    subTitle: null,
    isMenu: true,
    pathKey: SEMESTER,
    path: SEMESTER_PATH,
    privilege: [ROLE.STAFF],
};
export const VIEW_SEMESTER_SUBJECT = {
    title: '강의등록',
    subTitle: '학기별 개설대학의 강의를 등록 관리합니다.',
    isMenu: true,
    pathKey: SEMESTER_SUBJECT,
    path: SEMESTER_SUBJECT_PATH,
    privilege: [ROLE.STAFF],
};
export const VIEW_SEMESTER_STUDENT_UNIVERSITY = {
    title: '학생관리',
    subTitle: '가입한 본교 학생을 확인하고, 본인 가입여부를 검증합니다.',
    isMenu: true,
    pathKey: SEMESTER_STUDENT_UNIVERSITY,
    path: SEMESTER_STUDENT_UNIVERSITY_PATH,
    privilege: [ROLE.STAFF],
};
export const VIEW_SEMESTER_STUDENT_ENROLMENT_CHECK = {
    title: '수강검증',
    subTitle: '수강 학기별 본교 학생의 수강 자격을 승인하고, 수강과목을 확인합니다.',
    isMenu: true,
    pathKey: SEMESTER_STUDENT_ENROLMENT_CHECK,
    path: SEMESTER_STUDENT_ENROLMENT_CHECK_PATH,
    privilege: [ROLE.STAFF],
};
export const VIEW_SEMESTER_ENROLMENT_STATUS = {
    title: '학점교류 수강신청현황',
    subTitle: '학점교류 수강 신청한 타교 학생에 대해 수강등록을 위한 아이디 발급 및 수강과목별 등록을 진행합니다.',
    isMenu: true,
    pathKey: SEMESTER_ENROLMENT_STATUS,
    path: SEMESTER_ENROLMENT_STATUS_PATH,
    privilege: [ROLE.STAFF],
};
export const VIEW_SEMESTER_TOTAL_ENROLMENT_STATUS = {
    title: '전체 수강신청현황',
    subTitle: '전체 수강신청 현황에 대해 확인하고 해당 데이터를 다운로드 받을 수 있습니다.',
    isMenu: true,
    pathKey: SEMESTER_TOTAL_ENROLMENT_STATUS,
    path: SEMESTER_TOTAL_ENROLMENT_STATUS_PATH,
    privilege: [ROLE.STAFF],
};
export const VIEW_SEMESTER_ENROLMENT_MANAGEMENT = {
    title: '수강신청 설정관리',
    subTitle: '대학별 수강신청 기간을 설정하고, 대학별 수강 신청 유의사항을 등록할 수 있습니다.',
    isMenu: true,
    pathKey: SEMESTER_ENROLMENT_MANAGEMENT,
    path: SEMESTER_ENROLMENT_MANAGEMENT_PATH,
    privilege: [ROLE.STAFF],
};

/* -------------------------------------------- */
let VIEW_ENROLMENT = {
    title: '수강신청',
    subTitle: null,
    isMenu: true,
    pathKey: ENROLMENT,
    path: ENROLMENT_PATH,
    privilege: [ROLE.STUDENT],
};
export const VIEW_ENROLMENT_SEARCH_SUBJECT = {
    title: '수강신청',
    subTitle: (
        <>수강신청기간 동안 수강신청을 진행합니다. 수강신청 결과 화면을 통해 수강등록상태를 확인할 수 있습니다.</>
    ),
    isMenu: true,
    pathKey: ENROLMENT_SEARCH_SUBJECT,
    path: ENROLMENT_SEARCH_SUBJECT_PATH,
    privilege: [ROLE.STUDENT],
};
export const VIEW_ENROLMENT_ENROLMENT_RESULT = {
    title: '수강신청 결과',
    subTitle: (
        <>
            수강신청은 “수강신청” &gt; “수강자격검증(소속대학)” &gt; “학점교류신청허가(개설대학)” 단계로 진행됩니다.
            <br />
        </>
    ),
    isMenu: true,
    pathKey: ENROLMENT_ENROLMENT_RESULT,
    path: ENROLMENT_ENROLMENT_RESULT_PATH,
    privilege: [ROLE.STUDENT],
};
export const VIEW_ENROLMENT_SCHEDULE_TABLE = {
    title: '수강 시간표',
    subTitle: <>혁신융합대학사업(미래자동차) 수강 시간표 확인 및 자신의 시간표를 추가할 수 있습니다.</>,
    isMenu: true,
    pathKey: ENROLMENT_SCHEDULE_TABLE,
    path: ENROLMENT_SCHEDULE_TABLE_PATH,
    privilege: [ROLE.STUDENT],
};

/* -------------------------------------------- */

let VIEW_COMMUNITY = {
    title: '커뮤니티',
    subTitle: null,
    isMenu: true,
    pathKey: COMMUNITY,
    path: COMMUNITY_PATH,
    privilege: [],
};
export const VIEW_COMMUNITY_NOTICE = {
    title: '공지사항',
    subTitle: null,
    isMenu: true,
    pathKey: COMMUNITY_NOTICE,
    path: COMMUNITY_NOTICE_PATH,
    privilege: [],
};
export const VIEW_COMMUNITY_NOTICE_ADD = {
    title: '공지사항 등록',
    subTitle: null,
    isMenu: false,
    pathKey: COMMUNITY_NOTICE_ADD,
    path: COMMUNITY_NOTICE_ADD_PATH,
    privilege: [ROLE.ADMIN, ROLE.STAFF],
};
export const VIEW_COMMUNITY_NOTICE_DETAIL = {
    title: '공지사항 상세',
    subTitle: null,
    isMenu: false,
    pathKey: COMMUNITY_NOTICE_DETAIL,
    path: COMMUNITY_NOTICE_DETAIL_PATH,
    privilege: [],
};
export const VIEW_COMMUNITY_NOTICE_EDIT = {
    title: '공지사항 수정',
    subTitle: null,
    isMenu: false,
    pathKey: COMMUNITY_NOTICE_EDIT,
    path: COMMUNITY_NOTICE_EDIT_PATH,
    privilege: [ROLE.ADMIN, ROLE.STAFF],
};
export const VIEW_COMMUNITY_FAQ = {
    title: 'FAQ',
    subTitle: null,
    isMenu: true,
    pathKey: COMMUNITY_FAQ,
    path: COMMUNITY_FAQ_PATH,
    privilege: [],
};
export const VIEW_COMMUNITY_FAQ_ADD = {
    title: 'FAQ 등록',
    subTitle: null,
    isMenu: false,
    pathKey: COMMUNITY_FAQ_ADD,
    path: COMMUNITY_FAQ_ADD_PATH,
    privilege: [ROLE.ADMIN, ROLE.STAFF],
};
export const VIEW_COMMUNITY_FAQ_DETAIL = {
    title: 'FAQ 상세',
    subTitle: null,
    isMenu: false,
    pathKey: COMMUNITY_FAQ_DETAIL,
    path: COMMUNITY_FAQ_DETAIL_PATH,
    privilege: [],
};
export const VIEW_COMMUNITY_FAQ_EDIT = {
    title: 'FAQ 수정',
    subTitle: null,
    isMenu: false,
    pathKey: COMMUNITY_FAQ_EDIT,
    path: COMMUNITY_FAQ_EDIT_PATH,
    privilege: [ROLE.ADMIN, ROLE.STAFF],
};
export const VIEW_COMMUNITY_QNA = {
    title: '질의응답',
    subTitle: null,
    isMenu: true,
    pathKey: COMMUNITY_QNA,
    path: COMMUNITY_QNA_PATH,
    privilege: [],
};
export const VIEW_COMMUNITY_QNA_ADD = {
    title: '질의 등록',
    subTitle: '질의 내용은 한번 작성되면 수정될 수 없습니다. 새로운 질문이 있는 경우 신규 등록하세요.',
    isMenu: false,
    pathKey: COMMUNITY_QNA_ADD,
    path: COMMUNITY_QNA_ADD_PATH,
    privilege: [ROLE.STUDENT, ROLE.ADMIN, ROLE.STAFF],
};
export const VIEW_COMMUNITY_QNA_DETAIL = {
    title: '질의응답 상세',
    subTitle: null,
    isMenu: false,
    pathKey: COMMUNITY_QNA_DETAIL,
    path: COMMUNITY_QNA_DETAIL_PATH,
    privilege: [],
};
export const VIEW_COMMUNITY_QNA_EDIT = {
    title: '답변 등록',
    subTitle: '질의에 대한 답변을 등록/수정합니다.',
    isMenu: false,
    pathKey: COMMUNITY_QNA_EDIT,
    path: COMMUNITY_QNA_EDIT_PATH,
    privilege: [ROLE.ADMIN, ROLE.STAFF],
};

export let VIEWS = {
    ...VIEW_HOME,
    views: new Map([
        // TODO 삭제
        // [TEST, { ...VIEW_TEST, views: new Map([[TEST_MODAL, { ...VIEW_TEST_MODAL, views: null }]]) }],
        [
            SUBJECT_SEARCH,
            {
                ...VIEW_SUBJECT_SEARCH,
                views: new Map([
                    [
                        SUBJECT_SEARCH_BODY,
                        {
                            ...VIEW_SUBJECT_SEARCH_BODY,
                            views: null,
                        },
                    ],
                ]),
            },
        ],
        [
            SYSTEM,
            {
                ...VIEW_SYSTEM,
                views: new Map([
                    [
                        SYSTEM_TERM,
                        {
                            ...VIEW_SYSTEM_TERM,
                            views: null,
                        },
                    ],
                    [
                        SYSTEM_ENROLMENT_NOTICE,
                        {
                            ...VIEW_SYSTEM_ENROLMENT_NOTICE,
                            views: null,
                        },
                    ],
                    [
                        SYSTEM_UNIVERSITY,
                        {
                            ...VIEW_SYSTEM_UNIVERSITY,
                            views: null,
                        },
                    ],
                    [
                        SYSTEM_UNIVERSITY_MANAGER,
                        {
                            ...VIEW_SYSTEM_UNIVERSITY_MANAGER,
                            views: null,
                        },
                    ],
                    [
                        SYSTEM_SUBJECT_CODE,
                        {
                            ...VIEW_SYSTEM_SUBJECT_CODE,
                            views: null,
                        },
                    ],
                    [
                        SYSTEM_COMMON_CODE,
                        {
                            ...VIEW_SYSTEM_COMMON_CODE,
                            views: null,
                        },
                    ],
                    [
                        SYSTEM_USER,
                        {
                            ...VIEW_SYSTEM_USER,
                            views: null,
                        },
                    ],
                    [
                        SYSTEM_LOGIN_HISTORY,
                        {
                            ...VIEW_SYSTEM_LOGIN_HISTORY,
                            views: null,
                        },
                    ],
                ]),
            },
        ],
        [
            SEMESTER,
            {
                ...VIEW_SEMESTER,
                views: new Map([
                    [
                        SEMESTER_SUBJECT,
                        {
                            ...VIEW_SEMESTER_SUBJECT,
                            views: null,
                        },
                    ],
                    [
                        SEMESTER_STUDENT_UNIVERSITY,
                        {
                            ...VIEW_SEMESTER_STUDENT_UNIVERSITY,
                            views: null,
                        },
                    ],
                    [
                        SEMESTER_STUDENT_ENROLMENT_CHECK,
                        {
                            ...VIEW_SEMESTER_STUDENT_ENROLMENT_CHECK,
                            views: null,
                        },
                    ],
                    [
                        SEMESTER_ENROLMENT_STATUS,
                        {
                            ...VIEW_SEMESTER_ENROLMENT_STATUS,
                            views: null,
                        },
                    ],
                    [
                        SEMESTER_TOTAL_ENROLMENT_STATUS,
                        {
                            ...VIEW_SEMESTER_TOTAL_ENROLMENT_STATUS,
                            views: null,
                        },
                    ],
                    [
                        SEMESTER_ENROLMENT_MANAGEMENT,
                        {
                            ...VIEW_SEMESTER_ENROLMENT_MANAGEMENT,
                            views: null,
                        },
                    ],
                ]),
            },
        ],
        [
            ENROLMENT,
            {
                ...VIEW_ENROLMENT,
                views: new Map([
                    [
                        ENROLMENT_SEARCH_SUBJECT,
                        {
                            ...VIEW_ENROLMENT_SEARCH_SUBJECT,
                            views: null,
                        },
                    ],
                    [
                        ENROLMENT_ENROLMENT_RESULT,
                        {
                            ...VIEW_ENROLMENT_ENROLMENT_RESULT,
                            views: null,
                        },
                    ],
                    [
                        ENROLMENT_SCHEDULE_TABLE,
                        {
                            ...VIEW_ENROLMENT_SCHEDULE_TABLE,
                            views: null,
                        },
                    ],
                ]),
            },
        ],
        [
            SMS,
            {
                ...VIEW_SMS,
                views: new Map([
                    [SMS_SEND, { ...VIEW_SMS_SEND, views: null }],
                    [SMS_HISTORY, { ...VIEW_SMS_HISTORY, views: null }],
                ]),
            },
        ],
        [
            COMMUNITY,
            {
                ...VIEW_COMMUNITY,
                views: new Map([
                    [
                        COMMUNITY_NOTICE,
                        {
                            ...VIEW_COMMUNITY_NOTICE,
                            views: new Map([
                                [
                                    COMMUNITY_NOTICE_ADD,
                                    {
                                        ...VIEW_COMMUNITY_NOTICE_ADD,
                                        views: null,
                                    },
                                ],
                                [
                                    COMMUNITY_NOTICE_DETAIL,
                                    {
                                        ...VIEW_COMMUNITY_NOTICE_DETAIL,
                                        views: null,
                                    },
                                ],
                                [
                                    COMMUNITY_NOTICE_EDIT,
                                    {
                                        ...VIEW_COMMUNITY_NOTICE_EDIT,
                                        views: null,
                                    },
                                ],
                            ]),
                        },
                    ],
                    [
                        COMMUNITY_FAQ,
                        {
                            ...VIEW_COMMUNITY_FAQ,
                            views: new Map([
                                [
                                    COMMUNITY_FAQ_ADD,
                                    {
                                        ...VIEW_COMMUNITY_FAQ_ADD,
                                        views: null,
                                    },
                                ],
                                [
                                    COMMUNITY_FAQ_DETAIL,
                                    {
                                        ...VIEW_COMMUNITY_FAQ_DETAIL,
                                        views: null,
                                    },
                                ],
                                [
                                    COMMUNITY_FAQ_EDIT,
                                    {
                                        ...VIEW_COMMUNITY_FAQ_EDIT,
                                        views: null,
                                    },
                                ],
                            ]),
                        },
                    ],
                    [
                        COMMUNITY_QNA,
                        {
                            ...VIEW_COMMUNITY_QNA,
                            views: new Map([
                                [
                                    COMMUNITY_QNA_ADD,
                                    {
                                        ...VIEW_COMMUNITY_QNA_ADD,
                                        views: null,
                                    },
                                ],
                                [
                                    COMMUNITY_QNA_DETAIL,
                                    {
                                        ...VIEW_COMMUNITY_QNA_DETAIL,
                                        views: null,
                                    },
                                ],
                                [
                                    COMMUNITY_QNA_EDIT,
                                    {
                                        ...VIEW_COMMUNITY_QNA_EDIT,
                                        views: null,
                                    },
                                ],
                            ]),
                        },
                    ],
                ]),
            },
        ],
    ]),
};
